export default {"src":"/_next/static/media/public-procurement.fa031195.svg","height":422,"width":352,"blurWidth":0,"blurHeight":0};